import React, { Component } from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { setHeader } from '../../actions/header-actions';

const withTracker = (WrappedComponent) => {
    const trackPage = (page, category, properties) => {
        // Segment
        if (window?.analytics) {
            if (category) {
                window.analytics.page(category, page, properties || {});
            } else {
                window.analytics.page(page, properties || {});
            }
        }

        if (window?.pixie) {
            window.pixie('event', 'LandingPage');
        }
    };

    const HOC = class extends Component {
        componentDidMount() {
            const page = this.props.location.pathname + this.props.location.search;
            trackPage(page);
            const { auth } = this.props;
            if (auth.user) {
                if (window?.analytics) {
                    const { email, firstName, lastName } = auth.user;
                    window.analytics.identify(auth.user.id, {
                        email,
                        firstName,
                        lastName,
                    });
                }
            } else if (window?.analytics) {
                const userId = window?.analytics.user && window?.analytics.user().id();
                if (userId) {
                    window.analytics.reset();
                }
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            const { setHeaderOptions } = this.props;

            const matchedRoutes = matchRoutes(this.props.route.routes, nextProps.location.pathname);
            const nextRoute = matchedRoutes[0]?.route;

            setHeaderOptions(nextRoute?.header ? nextRoute.header : {});

            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;
            const category = nextRoute?.analyticsCategory;

            if (currentPage !== nextPage) {
                if (currentPage) {
                    trackPage(nextPage, category, {
                        referrer: currentPage,
                    });
                } else {
                    trackPage(nextPage, category);
                }
            }
        }

        componentDidUpdate(prevProps) {
            const { auth } = this.props;
            if (!prevProps.auth.user && auth.user) {
                if (window?.analytics) {
                    const { email, firstName, lastName } = auth.user;
                    window.analytics.identify(auth.user.id, {
                        email,
                        firstName,
                        lastName,
                    });
                }
            }
            if (prevProps.auth.user && !auth.user) {
                if (window?.analytics) {
                    window.analytics.reset();
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps, { setHeaderOptions: setHeader })(HOC);
};

export default withTracker;
